import { render, staticRenderFns } from "./LostListPage.vue?vue&type=template&id=6bccd9b4&scoped=true&"
import script from "./LostListPage.vue?vue&type=script&lang=js&"
export * from "./LostListPage.vue?vue&type=script&lang=js&"
import style0 from "./LostListPage.vue?vue&type=style&index=0&id=6bccd9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bccd9b4",
  null
  
)

export default component.exports